import { motion } from "framer-motion";
import { TID } from "@/lib/testIds";
import { GlowCard } from "@/components/ui/spotlight-card";
import TextReveal from "./TextReveal";

const TEAM = [
  { name: "Paras Devgun",  role: "Advocate · Founding Partner", tag: "MSMED Act · Arbitration", glow: "purple" },
  { name: "Manjul Kukreja", role: "Advocate · Co-founder",       tag: "Policy & Litigation",    glow: "gold"   },
  { name: "Jayseeka Virdi", role: "Head of People",              tag: "HR & Operations",         glow: "purple" },
  { name: "Mohit",          role: "Client Success",              tag: "Sanction & Disbursement", glow: "purple" },
  { name: "Vishal Kaushik", role: "Analyst · Project Funding",   tag: "DPR · Structuring",       glow: "gold"   },
  { name: "Ritik Jangra",   role: "Associate · Subsidies",       tag: "Filings & DPR",           glow: "purple" },
];

const initials = (n) =>
  n.split(" ").map((p) => p[0]).join("").slice(0, 2).toUpperCase();

export const About = () => (
  <section
    id="about"
    data-testid={TID.about.root}
    className="relative bg-navy text-white py-24 md:py-32 noise overflow-hidden"
  >
    <div aria-hidden className="absolute top-0 right-1/4 h-[520px] w-[520px] rounded-full bg-[color:var(--violet)]/35 blur-[160px]" />
    <div aria-hidden className="absolute bottom-0 left-1/4 h-[420px] w-[420px] rounded-full bg-[color:var(--gold)]/20 blur-[140px]" />

    <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <div className="grid grid-cols-12 gap-6 pb-14 md:pb-20 border-b border-white/10">
        <div className="col-span-12 md:col-span-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-[color:var(--gold)]">
            08 — About · Team
          </p>
        </div>
        <div className="col-span-12 md:col-span-8">
          <TextReveal as="h2" className="font-serif tracking-tight text-4xl md:text-6xl leading-[1.02]">
            A venture of Sera One — policy, law, and money in one room.
          </TextReveal>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-6 md:gap-10 pt-14 md:pt-20">
        <div className="col-span-12 lg:col-span-5 space-y-6">
          <p className="text-white/75 text-[16px] md:text-[17px] leading-relaxed">
            <TextReveal>
              MSMEmoney.ai is a DPIIT-recognized startup incubated by Sera One Pvt. Ltd., a policy and legal consulting firm serving industry across northern India. Our team includes practicing advocates with deep expertise in the MSMED Act, 2006 and state industrial-policy frameworks.
            </TextReveal>
          </p>
          <p className="text-white/75 text-[16px] md:text-[17px] leading-relaxed">
            <TextReveal>
              We work primarily with promoters in Haryana — Panipat, Sonipat, Gurugram, Faridabad — and are now expanding pan-India as more MSMEs look for one accountable partner who can carry a case from application to disbursement, and from delayed payment to recovery.
            </TextReveal>
          </p>
          <div className="grid grid-cols-2 gap-4 pt-4">
            <div className="border border-white/15 p-5">
              <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-white/50">
                Parent
              </p>
              <p className="mt-2 font-serif text-xl">Sera One Pvt. Ltd.</p>
              <p className="mt-1 text-[12px] text-white/60 leading-snug">
                Policy &amp; Legal Consulting
              </p>
            </div>
            <div className="border border-white/15 p-5">
              <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-white/50">
                Recognized by
              </p>
              <p className="mt-2 font-serif text-xl">DPIIT, Govt. of India</p>
            </div>
          </div>
        </div>

        <div className="col-span-12 lg:col-span-7">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
            {TEAM.map((t, i) => (
              <motion.div
                key={t.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10% 0px" }}
                transition={{ delay: i * 0.06, duration: 0.7 }}
              >
                <GlowCard
                  glowColor={t.glow}
                  customSize
                  className="w-full !aspect-[4/5] !rounded-none border-white/10 flex flex-col justify-between !p-5 !gap-0"
                >
                  <div
                    className="grid h-12 w-12 place-items-center border border-white/25 font-serif text-lg text-white/85"
                    aria-hidden
                  >
                    {initials(t.name)}
                  </div>
                  <div>
                    <TextReveal className="font-serif text-lg md:text-xl leading-tight text-white">
                      {t.name}
                    </TextReveal>
                    <p className="mt-1 text-xs md:text-[13px] text-white/65">
                      {t.role}
                    </p>
                    <p className="mt-3 font-mono text-[9px] uppercase tracking-[0.22em] text-[color:var(--gold)]/85">
                      {t.tag}
                    </p>
                  </div>
                </GlowCard>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default About;
